import cogoToast from "cogo-toast";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useApproveDocumentMutation } from "../../../../../../../../../../redux/apiSlice";
import Reject from "./Reject";

const AcceptReject = ({doc, topRef, refreshDocs}) => {
    
    const [ approveDocument, { isLoading, isSuccess },  ] = useApproveDocumentMutation();
    // const [isLoading, notification] = ["", ""];
    const [rejectAction, setRejectAction] = useState(false);
    const isSuccessRef = useRef(false);

    // Back
    const cancel = useCallback(_ => {
        topRef.current.scrollIntoView({ behavior: 'smooth' });
        setTimeout(_ => setRejectAction(false), 200)
    }, [topRef])

    useEffect(() => {
        if (isSuccess && isSuccessRef.current) {
            isSuccessRef.current = false;
            cogoToast.success("Document Approved");
            refreshDocs({status: "APPROVED", });
            cancel();
        }
    }, [isSuccess,  cancel, refreshDocs]);


    return <div className="px-10 pt-5 pb-5">
                {
                    rejectAction ? <Reject doc={doc} cancel={cancel} refreshDocs={refreshDocs}/>
                        : <div className="row justify-content-center">
                            <div className={`col-md-6 pb-5 ${doc.status.toUpperCase() === "PENDING" || doc.status.toUpperCase() === "REJECTED" ? "" : "d-none"}`}>
                                <button 
                                    className="btn btn-lg btn-block btn-success font-weight-bold" 
                                    type="button"
                                    disabled={isLoading || ((doc.type === "PICTURE_ID" || doc.type === "PICTURE_ID_PROOF_OF_ADDRESS") && (!doc.idType || !doc.idValue)) || (doc.type === "PROOF_OF_ADDRESS" && !doc.idType)}
                                    onClick={_ => { isSuccessRef.current = true; approveDocument({...doc, meta: doc})}}
                                >
                                    APPROVE
                                </button>
                            </div>
                            <div className={`col-md-6 pb-5 ${doc.status.toUpperCase() === "PENDING" || doc.status.toUpperCase() === "APPROVED" ? "" : "d-none"}`}>
                                <button 
                                    className="btn btn-lg btn-block btn-danger font-weight-bold" 
                                    onClick={_ => setRejectAction(true)}
                                    disabled={isLoading}
                                >
                                    REJECT
                                </button>
                            </div>
                        </div>
                }
            </div>  
}

export default AcceptReject;